import { memo } from 'react';
import { Box } from '@mui/material';
import { COLOR_BG_BLACK_2 } from 'shared';
import HomeBg from 'shared/assets/video/home_background.webm';

export const Background = memo(() => {
  return (
    <>
      <Box
        component="video"
        autoPlay
        muted
        loop
        playsInline
        sx={{
          objectFit: 'cover',
          position: 'absolute',
          zIndex: -2,
          top: { xs: 3000, sm: 1950, md: 1550 },
          height: { xs: 700, md: 1434 },
          left: 0,
          width: '100vw',
        }}
      >
        <source src={HomeBg} type="video/webm" />
      </Box>
      <Box
        sx={{
          background: `linear-gradient(transparent 10%, ${COLOR_BG_BLACK_2})`,
          objectFit: 'cover',
          position: 'absolute',
          zIndex: -1,
          top: { xs: 3000, sm: 1950, md: 1550 },
          height: { xs: 700, md: 1434 },
          left: 0,
          width: '100vw',
          overflow: 'hidden',
        }}
      />
    </>
  );
});

Background.displayName = 'Background';
